<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title text-center">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol> </CCol>
            </CRow>
            <!-- Title page -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.throttlingDeliveryLogs.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'throttlingDeliveryLogs',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="
                                            tables.throttlingDeliveryLogs
                                                .allFields
                                        "
                                        :activeFields.sync="
                                            tables.throttlingDeliveryLogs.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.throttlingDeliveryLogs.items"
                                    :fields.sync="
                                        tables.throttlingDeliveryLogs.fields
                                    "
                                    :items-per-page="
                                        tables.throttlingDeliveryLogs.rows
                                    "
                                    :loading="
                                        tables.throttlingDeliveryLogs.loading
                                    "
                                    :columnFilterValue.sync="
                                        tables.throttlingDeliveryLogs
                                            .columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.throttlingDeliveryLogs
                                            .sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.throttlingDeliveryLogs"
                                    :resizable="true"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/throttling-service/throttling-deliveries/' +
                                                    uuid +
                                                    '/logs'
                                                "
                                                :baseURL="ApiSass"
                                                :adapterFilters="
                                                    adapterFiltersInExport
                                                "
                                                delimiter=";"
                                                stringDelimiter="'"
                                                :table="
                                                    tables.throttlingDeliveryLogs
                                                "
                                            />
                                        </div>
                                    </template>
                                    <template #LeadId="{ item }">
                                        <RouterLink
                                            :to="
                                                '/app/campaigns/' +
                                                uuid +
                                                '/leads/' +
                                                item.LeadId
                                            "
                                            >{{ item.LeadId }}</RouterLink
                                        >
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter
                                v-show="
                                    tables.throttlingDeliveryLogs.items.length >
                                    0
                                "
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.throttlingDeliveryLogs.page
                                        "
                                        :pages="
                                            tables.throttlingDeliveryLogs
                                                .total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="
                                            tables.throttlingDeliveryLogs
                                                .loading
                                        "
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'throttlingDeliveryLogs',
                    })
                "
            >
                <template #title> Don't have Throttling deliveries </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'throttlingDeliveryLogs',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('throttlingDeliveryLogs'),
                                updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import NoItemsContainer from "~/components/NoItemsContainer";
import CCTable from "~/components/CCTable";
import ButtonBack from "£lement/ButtonBack";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
import { isReservedField } from "~/utils/tables";
/** Icons */
import { eraser } from "~/assets/icons/js/eraser";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilTrash,
    cilGroup,
    cilArrowThickFromRight,
} from "@coreui/icons";

export default {
    name: "ThrottlingDeliveryLogsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        FilterFields,
        ButtonExport,
        NoItemsContainer,
        TableSettings,
        CCTable,
        ButtonBack,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilTrash,
        cilGroup,
        cilArrowThickFromRight,
        eraser,
    },
    watch: {
        "tables.throttlingDeliveryLogs.loading": {
            handler(newValue) {
                this.updatePageLoading(newValue);
            },
            deep: true,
        },
    },
    data() {
        return {
            tables: {
                throttlingDeliveryLogs: {
                    fields: [
                        {
                            key: "ThrottlingDeliveryLogId",
                            label: "#",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "LeadId",
                            label: "Lead Id",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _active: true,
                        },
                        {
                            key: "Email",
                            label: "Email",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _active: true,
                        },
                        {
                            key: "Phone",
                            label: "Phone",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _active: true,
                        },
                        {
                            key: "FirstName",
                            label: "First Name",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _active: true,
                        },
                        {
                            key: "LastName",
                            label: "Last Name",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _active: true,
                        },
                        {
                            key: "ThrottlingDeliveryLogStatus",
                            label: "Throttling Log Status",
                            sorter: false,
                            filter: true,
                            _filter: {
                                active: false,
                                value: null,
                                condition: "is_equal_to",
                                type: "select",
                                options: [
                                    { value: "pending", label: "pending" },
                                    { value: "stoped", label: "stoped" },
                                    { value: "completed", label: "completed" },
                                ],
                            },
                            active: true,
                        },
                        {
                            key: "ThrottlingDeliveryLogCreatedAt",
                            label: "Throttling Log Creation at", 
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "ThrottlingDeliveryLogUpdatedAt",
                            label: "Throttling Log Updated at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "CreatedAt",
                            label: "Capture Creation at", 
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    matchResponseCurrentPage: "currentPage",
                    total_pages: 1,
                    matchResponsePages: "pages",
                    loading: true,
                    hover: true,
                    responsive: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    dateFieldFilter: "ThrottlingDeliveryLogCreatedAt",
                    orderField: "ThrottlingDeliveryLogId",
                    matchResponse: "data",
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                    loadQueryFromUrl: true,
                },
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "throttlingDeliveryLogs",
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                },
                url: `/throttling-service/throttling-deliveries/${this.uuid}/logs`,
            });

            this.tables.throttlingDeliveryLogs.itemSelected = null;

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        adapterFiltersInExport(query) {
            query = {
                ...query,
                fields: this.tables.throttlingDeliveryLogs.fields
                    .filter((field) => !isReservedField(field))
                    .map((field) => {
                        return field.key;
                    }),
            };
            return query;
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>
